import { request as __request } from '../request/request';
import { OpenAPI } from '../request/open-api';
import {
  ConvertGEMacResponseDto,
  EcgAnalysisResponseDto,
  StudyEcgDto,
  DownloadECGItem,
  StudyStatisticResponseDto,
} from 'types/types';
import { CancelablePromise } from '../request/cancelable-promise';
import { ECGStudyResponseDto } from 'types/types/dto/ecg-study-response-dto';
import { StudyFullSamplesResponseDto } from 'types/types/dto';

export const convertGemacXML = (xmlFile: File, waveformId: string) => {
  const formData = new FormData();
  formData.append('file', xmlFile);

  return __request<ConvertGEMacResponseDto>(OpenAPI, {
    method: 'PUT',
    url: `/study/mac_upload?waveform_id=${waveformId}`,
    body: formData,
    mediaType: 'text/xml',
  });
};

export const convertHolterECG = (ecgFile: File, waveformId: string, holterOffset: number) => {
  const file = new Blob([ecgFile], { type: 'application/octet-stream' });
  const fileFormData = new FormData();
  fileFormData.append('file', file);
  fileFormData.append('waveformId', waveformId);
  fileFormData.append('holterOffset', holterOffset.toString());

  return __request<ConvertGEMacResponseDto>(OpenAPI, {
    method: 'PUT',
    url: `/study/holter-upload`,
    body: fileFormData,
  });
};

export const saveEcgIndex = ({
  source,
  status,
  subjectId,
  samples,
  ecgWaveformId,
  diagnosis,
  recordingComment,
}: StudyEcgDto) => {
  const formData: EcgAnalysisResponseDto = {
    subjectId,
    samples,
    source,
    status,
    ecgWaveformId,
    diagnosis,
    recordingComment,
  };

  return __request<number>(OpenAPI, {
    method: 'PUT',
    url: `/study/study-index`,
    body: formData,
  });
};

export const getFacilityEcgs = (
  facilityId: String,
  limit: number,
  skip: number,
): CancelablePromise<ECGStudyResponseDto> => {
  return __request(OpenAPI, {
    method: 'GET',
    url: `/study/subjects_by_facility/${facilityId}`,
    path: {
      caregiverId: String,
    },
    query: {
      limit: limit,
      skip: skip,
    },
  });
};

export const getReferenceECGData = (waveformId: String): CancelablePromise<DownloadECGItem> => {
  return __request(OpenAPI, {
    method: 'GET',
    url: `/study/reference-ecg/${waveformId}`,
  });
};

export const getStudyItemsByFacilityId = (
  facilityId: String,
  limit = 10,
  skip = 0,
): CancelablePromise<ECGStudyResponseDto> => {
  return __request(OpenAPI, {
    method: 'GET',
    url: `study/admin-subjects/${facilityId}`,
    query: {
      limit: limit,
      skip: skip,
    },
  });
};

export const getStudyAdminStatistics = (): CancelablePromise<StudyStatisticResponseDto | null> => {
  return __request(OpenAPI, {
    method: 'GET',
    url: 'study/admin-subjects/statistics/',
  });
};

export const getStudyFullSamples = (
  waveformId: string,
  s3Prefix: string,
): CancelablePromise<StudyFullSamplesResponseDto> => {
  return __request(OpenAPI, {
    method: 'GET',
    url: 'study/compared-full-samples',
    query: {
      waveform_id: waveformId,
      s3_prefix: s3Prefix,
    },
  });
};
